import { virtualDir } from "./skyward.base.global";
import { registerEvents } from "./skyward.ui.events";
import { loadContent } from "./skyward.ui.window";
import { JQueryInput } from "./types";

const skyward = window.skyward;

const classes =
{
    sortable: "sortable",
    show: "show",
    hide: "hide",
};

type DockData =
    {
        primarykeyid: string;
        [key: string]: string;
    };

const dockBar = $("#dockBar");
const dockBarInnerContainer = $('#dockBarInnerContainer');
let displayDockToolbar = dockBar.hasClass(classes.show);

const events =
{
    init,
    click: dockButtonClick,
    add: addToDock,
    edit: editDock,
};

registerEvents("dock", events);

function init(this: JQueryInput)
{
    const dock = $(this);

    const sortableOptions =
    {
        cursor: "move",
        scroll: true,
        containment: "parent",
        items: `> .${classes.sortable}`,
        tolerance: "pointer",
        distance: 5,
        start: function (_event: any, ui: any)
        {
            ui.item[0].oldclick = ui.item[0].onclick;
            ui.item[0].onclick = null;
        },
        stop: function (_event: any, ui: any)
        {
            setTimeout(function ()
            {
                ui.item[0].onclick = ui.item[0].oldclick;
            }, 500);
        },
        update: function ()
        {
            updateDock();
        }
    };

    dockBarInnerContainer.sortable(sortableOptions);
    dockBarInnerContainer.disableSelection();

    dock.debounce("click", saveDockState);
}

function saveNewDockItem()
{
    return $.ajax(
    {
        url: `${virtualDir}SkySys/UserDock/AddToDock`,
        type: "POST",
        dataType: "viewparthtml",
        data:
        {
            DisplayOrder: dockBarInnerContainer[0].children.length - 1,
            ScreenFriendlyName: $("#friendlyNameContents").text()
        }
    }).promise();
};

function addToDock(this: JQueryInput): JQuery.Promise<any>
{
    const button = $(this);
    button.hide();
    return saveNewDockItem().done(function (data)
    {
        dockBarInnerContainer.append(data);
        refreshIfCurrentSreenIsDockList();
    });
};

function editDock(this: JQueryInput): JQuery.Promise<any>
{
    updateDock();
    return showReorderList();
};

function showReorderList()
{
    return loadContent('full', 'SkySys', 'UserDock', 'List', null, null);
};

function updateDock(): JQuery.Promise<any>
{
    const dockItems: { [key: string]: number } = {};
    let index = 1;
    dockBarInnerContainer.children(`.${classes.sortable}`).each(function ()
    {
        const dockData = $(this).data() as DockData;
        if (dockData)
        {
            dockItems[dockData.primarykeyid] = index;
            index++;
        }
    });

    return $.ajax(
    {
        url: `${virtualDir}SkySys/UserDock/UpdateDock`,
        type: "POST",
        dataType: "JSON",
        data:
        {
            DockItems: JSON.stringify(dockItems)
        },
        success: refreshIfCurrentSreenIsDockList,
    }).promise();
};

function refreshIfCurrentSreenIsDockList()
{
    const browseName = skyward.browse.getCurrentBrowseName();
    const browse = skyward.browse.browseList[browseName!];
    if (browseName !== null && browse?.browseModule === "SkySys" && browse?.browseObject === "UserDock")
    {
        skyward.browse.get('browse');
    }
};

function dockButtonClick(this: JQueryInput)
{
    const dockButton = $(this);
    displayDockToolbar ? hideDock.apply(dockButton) : showDock.apply(dockButton);
    dockButton.attr("aria-expanded", displayDockToolbar as unknown as string);
    $(window).resize();
};

function hideDock(this: JQuery<HTMLElement>)
{
    dockBar.removeClass(classes.show).addClass(classes.hide);
    this.removeClass(classes.show).addClass(classes.hide);
    displayDockToolbar = false;
};

function showDock(this: JQuery<HTMLElement>)
{
    dockBar.removeClass(classes.hide).addClass(classes.show);
    this.removeClass(classes.hide).addClass(classes.show);
    displayDockToolbar = true;
};

function saveDockState()
{
    return $.ajax(`${virtualDir}SkySys/UserDock/UpdateDockDisplay`,
        {
            type: "POST",
            dataType: "JSON",
            activityIndicator: { hideGlass: true },
            data: { showDockToolbar: displayDockToolbar }
        }).promise();
};